<template>
  <main id="shipment-tracking-main">
    <account-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" :accountType="shippers" :handling="true" :children="true"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('shipmentTracking.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="historical-caption-row">
        <el-col>
          <i class="el-icon-info red-armellini"></i>&nbsp;
          <span class="font-gray info-text"> {{ $t('customerService.shipment.historical') }} &nbsp;</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="red-link-bold"
            :href="aelis2HistoricalUrl"
          >
            {{ $t('common.here') }}
          </a>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" :xs="24" class="default-section-title">
              {{ $t('shipmentTracking.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="default-section-actions text-align-end">
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col v-if="device==='mobile'">
              <search-summary-mobile />
            </el-col>
            <el-col v-else>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import constants from '@/utils/constants';
import AccountList from '@/components/AccountList';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import SearchSummaryMobile from './SearchSummaryMobile';

export default {
  name: 'ShipmentTracking',
  components: {
    SearchFilter,
    SearchSummary,
    SearchSummaryMobile,
    AccountList
  },
  data() {
    return {
      actionMountChained: ['loads/setShipmentTrackingDefaultFilters'],
      actionSelectChained: ['loads/searchShipmentTracking'],
      shippers: constants.ACCOUNTS.TYPE[1].value
    };
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    aelis2HistoricalUrl: () => constants.AELIS2.URLS.SHIPMENTS
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
main#shipment-tracking-main {
  .search-summary-container {
    margin-top: 5px;
  }
}
</style>
